import { Routes } from '@angular/router';
import { policyRoutes } from './policy.routes';

const loginRoute = {
    path: 'login',
    loadChildren: () =>
        import('../pages/login/login.routes').then(m => m.LOGIN_ROUTES),
};

export const publicRoutes: Routes = [
    loginRoute,
    ...policyRoutes,
    { path: '**', redirectTo: '/login' },
];
